import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { Zap } from "lucide-react";

const UsageMeter = ({ subscription }) => {
  if (!subscription) return null;

  const isPro =
    subscription.tier === "pro_monthly" || subscription.tier === "pro_yearly";
  if (isPro) return null;

  const {
    searches_remaining,
    search_limit,
    search_period,
    analyses_remaining,
    analysis_limit,
    tier,
    tier_name,
  } = subscription;

  const searchPercent =
    search_limit > 0
      ? Math.max(0, (searches_remaining / search_limit) * 100)
      : 100;
  const analysisPercent =
    analysis_limit > 0
      ? Math.max(0, (analyses_remaining / analysis_limit) * 100)
      : 100;
  const barColor = (pct) =>
    pct > 50 ? "bg-emerald-500" : pct > 20 ? "bg-amber-500" : "bg-red-500";

  return (
    <Card className="bg-card border-border" data-testid="usage-meter">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-xs text-muted-foreground uppercase tracking-wider font-semibold">
            Usage
          </span>
          <Badge
            className={`text-[10px] border-0 ${
              tier === "free"
                ? "bg-secondary text-muted-foreground"
                : "bg-emerald-500/15 text-emerald-500"
            }`}
          >
            {tier_name}
          </Badge>
        </div>
        <div>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-muted-foreground">Searches</span>
            <span className="font-mono text-foreground">
              {searches_remaining === -1 ? "\u221e" : searches_remaining}/
              {search_limit === -1 ? "\u221e" : search_limit} per{" "}
              {search_period}
            </span>
          </div>
          <div className="h-1.5 bg-secondary rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full transition-all ${barColor(
                searchPercent
              )}`}
              style={{ width: `${searchPercent}%` }}
            />
          </div>
        </div>
        <div>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-muted-foreground">Analyses</span>
            <span className="font-mono text-foreground">
              {analyses_remaining === -1 ? "\u221e" : analyses_remaining}/
              {analysis_limit === -1 ? "\u221e" : analysis_limit} per week
            </span>
          </div>
          <div className="h-1.5 bg-secondary rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full transition-all ${barColor(
                analysisPercent
              )}`}
              style={{ width: `${analysisPercent}%` }}
            />
          </div>
        </div>
        {tier === "free" && (
          <button
            onClick={() => (window.location.href = "/billing")}
            className="w-full flex items-center justify-center gap-1.5 py-1.5 rounded-lg bg-emerald-500/10 text-emerald-500 text-xs font-semibold hover:bg-emerald-500/20 transition-colors"
            data-testid="upgrade-from-meter"
          >
            <Zap className="w-3 h-3" /> Upgrade to Pro
          </button>
        )}
      </CardContent>
    </Card>
  );
};

export default UsageMeter;
